import { z } from "zod";

export const backofficeFindGprsConsoResponseSchema = z.object({
  alertDate: z.coerce.date().nullable(),
  alertStatus: z.string().nullable(),
  volumeDate: z.coerce.date().nullable(),
  volumeReceived: z.number().nullable(),
  volumeSent: z.number().nullable(),
});

export type BackofficeFindGprsConsoResponse = z.infer<typeof backofficeFindGprsConsoResponseSchema>;
